import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavItemType } from '../nav-items/models/nav-item-type.enum';
import { NavItemModel } from '../nav-items/models/nav-item.model';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthStorage } from 'src/app/client/repositories/lib/auth';

@Component({
  selector: 'app-profile-menu-switch',
  templateUrl: './profile-menu-switch.component.html',
  styleUrls: ['./profile-menu-switch.component.scss'],
})
export class ProfileMenuSwitchComponent implements OnInit {
  @Output() emitSignOut = new EventEmitter<void>();

  requestAddressChangeItem = {
    name: 'header.addressChangeRequest',
    type: NavItemType.Button,
    class: 'btn btn-danger',
    onClick: () => {
      this.navigateToAddressChangeRequest();
    },
  } as NavItemModel;

  changePasswordItem = {
    name: 'header.changePassword',
    type: NavItemType.Button,
    class: 'btn btn-danger',
    onClick: () => {
      this.navigateToPasswordChange();
    },
  } as NavItemModel;

  signOutItem = {
    name: 'header.signOut',
    type: NavItemType.Button,
    class: 'btn btn-danger',
    onClick: () => {
      this.signOut();
    },
  } as NavItemModel;

  navItems: Array<NavItemModel> = [this.changePasswordItem, this.signOutItem];

  initials = '';

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private authStorage: AuthStorage
  ) {
    let name = localStorage.getItem('fullName');

    if (name) {
      this.initials =
        name.substring(0, 1).toUpperCase() +
        name
          .substring(name.indexOf(' ') + 1, name.indexOf(' ') + 2)
          .toUpperCase();
    }
  }

  signOut(): void {
    // this.isSignedIn = false;
    this.emitSignOut.emit();
    // this.authStorage.clear();
    // this.router.navigate(['/']);
  }

  navigateToPasswordChange(): void {
    this.router.navigate(['/auth/set-new-password']);
  }

  navigateToAddressChangeRequest(): void {
    this.router.navigate(['/auth/request-address-change']);
  }

  ngOnInit(): void {}
}
